<!--
<div class="sidebar">
    <div class="sidebar-content email-app-sidebar">
        <div class="email-app-menu">
            <div class="sidebar-menu-list">
                <div class="list-group list-group-labels">

                    <div class="me-4" style="min-width: 180px;">
                        <ul class=" step list-unstyled">
                            <li *ngFor="let step of steps; let i = index" class="mb-3">
                                <div class="d-flex align-items-start">
                                    <div
                                            class=" step-circle rounded-circle d-flex align-items-center justify-content-center me-2"
                                            [ngClass]="{
              'bg-primary text-white': currentStep === i,
              'border border-primary text-primary': currentStep !== i
            }"
                                            style="width: 30px; height: 30px"
                                    >
                                        {{ i + 1 }}
                                    </div>
                                    <div  class="step-label" [class.fw-bold]="currentStep === i">
                                        {{ step }}
                                        <div class="step-connector"></div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
 -->
<!-- Retour Button-->
<div class=" mb-3 retour"  (click)="retour()" style="padding-top: 24px; color: #2F2B3DE5">

    <i data-feather="arrow-left" [size]="20"> </i>
    Retour
</div>
<div class="  wizard-sidebar">
    <ul class="list-unstyled">

        <li *ngFor="let step of steps; let i = index" class="mb-3">
            <div class="d-flex align-items-start">
                <div class="step-circle rounded-circle d-flex align-items-center justify-content-center me-2 text-center" style="border: #1D328F 20px"
                     [ngClass]="{
            'bg-primary text-white': currentStep === i,
            'border  border-primary text-primary': currentStep !== i}" >
                    <div *ngIf="i <= currentStep">
                        <span class="num" [ngClass]="{'not-active-num': i > currentStep}">{{ num(i) }}</span>
                    </div>
                </div>
                <div class="step-label" [class.fw-bold]="currentStep === i">

                    <span class="txt-num">{{ step }}</span>
                </div>
            </div>
        </li>
    </ul>
    <!--<button (click)="onGoBack()" *ngIf="currentStep > 0" class="btn btn-secondary mt-4">Retour</button> -->
</div>